module.exports = __webpack_public_path__ + "static/media/gym.f4cf7bcd.jpg";